import { useEffect, useState } from "react";
import { ProductType } from "../../contexts/OrderContext";
import { calculatePriceFractionalToProduct, floatToPrice } from "../../functions/price_functions";
import './cartItem.css'
import { useOrder } from "../../hooks/useOrder";
import Swal from "sweetalert2";
import { QuantityButton } from "../QuantityButton";
import { ProdutoButtonQuantity } from "../ProductButton";
type CartItemProps = {
  product: ProductType;
  showOutStock?: boolean;
  motorTotvs?: boolean;
  typePluginspace?: string;
};


export function NewCartItem({ product, showOutStock = false, motorTotvs = false, typePluginspace = '' }: CartItemProps) {
  const [newQuantity, setNewQuantity] = useState(product.quantity);
  const [removed, setRemoved] = useState(false);
  const { changeProduct, removeProduct } = useOrder();

  const [priceAdditionals, setPriceAdditionals] = useState(0);

  const [loadingImage, setLoadingImage] = useState(true);

  useEffect(() => {
    if (product.additionals) {
      let _priceAdditionals = 0;
      product.additionals.map((additional) => (_priceAdditionals += additional.quantity * additional.price));
      setPriceAdditionals(_priceAdditionals)
    }
  }, [product.additionals]);

  function changeQuantity(value: number) {
    if (value < 1) {
      removeProductCart(product);
    } else if (value <= product.stock || showOutStock) {
      setNewQuantity(value);
      product.quantity = value;
      changeProduct(product, motorTotvs);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Estoque máximo atingido",
        text: "Não será mais possível aumentar a quantidade do produto",
      });
    }
  }

  function removeProductCart(product: ProductType) {
    Swal.fire({
      title: "Remover produto",
      text: "Deseja remover este produto do carrinho?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim!",
    }).then((result: any) => {
      if (result.isConfirmed) {
        setNewQuantity(0)
        product.quantity = 0;
        removeProduct(product, motorTotvs);
        // window.location.reload();
      }
    });
  }

  return (
    <div className="cartContent">
      <div className="product">
        <img src={product.image} alt="" />
        <div className="productInfo">
          <div className="name">
            <p>{product.name}</p>
          </div>

          <div className="productInfoBotton">
            <div className="price">
              {product.promotionalPrice === 0 ||
                product.promotionalPrice === product.unitPrice ? (
                <p>
                  {
                    product.type === 'fractional' ?
                      floatToPrice((calculatePriceFractionalToProduct(product) * product.quantity) + (priceAdditionals * product.quantity))
                      :
                      floatToPrice((product.unitPrice * product.quantity) + (priceAdditionals * product.quantity))
                  }
                </p>
              ) : (
                <p>
                  {floatToPrice(
                    product.promotionalPrice * product.quantity
                  )}
                </p>
              )}
            </div>
            <div className="options">

              <ProdutoButtonQuantity
                changeValuePositive={() => changeQuantity(newQuantity + 1)}
                changeValueNegative={() => changeQuantity(newQuantity - 1)}
                value={product.quantity} />
            </div>
          </div>
        </div>
      </div>
      <div className="productInfoSpecification">

        <span className="title">Grupo de Personalização</span>
        {Object.entries(product.variation).map((variation) => {

          if (
            variation[0] !== "VARIATION" &&
            variation[1] !== "NONE"
          ) {
            return (
              <li className="values">
                <span className="values"> {variation[1]}</span>
              </li>
            );
          } else {
            <></>;
          }
        })}
      </div>

      {product.observation && (
        <div className="productInfoSpecification">
          <span className="title">Comentários do cliente</span>
          <div className="comments">
            <p>{product.observation}</p>
          </div>
        </div>
      )}


      <div>

      </div>

    </div>
  )
}